import * as Types from '../../constants/actionTypes';
const initState = {
  assetTypeList: [],
  assetTypeErr: null,
}
export default (state = initState, action) => {
  switch (action.type) {
    case Types.LIST_ALL_ASSETS_TYPE_SUCCESS: {
      return {
        ...state,
        assetTypeList: action.payload
      }
    }
    case Types.LIST_ALL_ASSETS_TYPE_ERROR: {
      return {
        ...state,
        assetTypeErr: action.payload
      }
    }
    default:
      return state;
  }
};